import { Split } from 'components/layout/primitives'
import { CursorMods, FlexContainer } from 'components/styles'
import { useViewState } from '../store'
import { BlockComponent } from 'lib'
import { CalculatorIcon, CloseIcon, HelpIcon } from '../../icons'
import { SpaceProperties } from 'components/styles/definitions/size/typographyScale'

const ViewToggleConfig = {
	help: { text: 'Close', icon: CloseIcon },
	calculator: { text: 'Help', icon: HelpIcon }
}

export const ApprovabilityRibbon: BlockComponent = () => {
	const [view, { changeView }] = useViewState()
	const ActionIcon = ViewToggleConfig[view].icon
	return (
		<Split>
			<FlexContainer gap={SpaceProperties.Small}>
				<CalculatorIcon width={16} />
				Approvability Calculator
			</FlexContainer>
			<FlexContainer
				alignItems="center"
				gap={SpaceProperties.Small}
				onClick={() => changeView(view === 'help' ? 'calculator' : 'help')}
				modifiers={[CursorMods.Pointer]}
			>
				<ActionIcon width={20} />
				{ViewToggleConfig[view].text}
			</FlexContainer>
		</Split>
	)
}
